import axios from 'axios';
import { useCallback, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { API_BASE_URL, AUTH_TOKEN_KEY } from '../../../../constants';
import { toast } from 'react-toastify';

interface IUseFetchDownloadTemplateProps {
  action: 'add' | 'edit';
}

export const saveToLocal = (
  file: Blob,
  fileName: string = 'kick-add-products-template.xlsx',
) => {
  const link = document.createElement('a');
  const blobUrl = URL.createObjectURL(file);
  link.href = blobUrl;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  URL.revokeObjectURL(blobUrl);
  link.parentElement?.removeChild(link);
};

export const useFetchDownloadTemplate = (
  props: IUseFetchDownloadTemplateProps,
) => {
  const { action } = props;
  const [data, setData] = useState();
  const [isFetching, setIsFetching] = useState<boolean>(false);

  const showFailedFeedback = (message: string = '') => {
    toast.error(
      message ||
        'Failed to download your template file. Please try again later or contact our customer service.',
      {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      },
    );
  };

  const download = async () => {
    if (isFetching) {
      return;
    }

    setIsFetching(true);

    const fetchUrl =
      action === 'add'
        ? `${API_BASE_URL}/users/listing/download-template`
        : `${API_BASE_URL}/users/listing/export`;

    try {
      const response = await axios
        .get(fetchUrl, {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
          },
          responseType: 'blob',
        })
        .then((res) => {
          const fileName =
            action === 'add'
              ? 'kick-add-products-template.xlsx'
              : 'kick-edit-products-template.xlsx';
          saveToLocal(res.data, fileName);
          return res.data;
        });

      setData(response);
      setIsFetching(false);
      return {
        isSuccess: true,
        response,
      };
    } catch (err) {
      console.log("failed to download template file", err);
      setIsFetching(false);
      showFailedFeedback();
      return {
        isSuccess: false,
      };
    }
  };

  return {
    isFetching,
    data,
    download,
  };
};
